(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["velune-avant-apres"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('velune-before-after')) {
    customElements.define('velune-before-after', class extends HTMLElement {
      connectedCallback() {
        const range = this.querySelector('input[type="range"]');
        if (!range) return;
        const section = this.closest('.vba') || this;
        this.onInput = () => section.style.setProperty('--vba-pos', `${range.value}%`);
        range.addEventListener('input', this.onInput);
      }
      disconnectedCallback() {
        const range = this.querySelector('input[type="range"]');
        if (range && this.onInput) range.removeEventListener('input', this.onInput);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["velune-compte-a-rebours"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('velune-countdown')) {
    customElements.define('velune-countdown', class extends HTMLElement {
      connectedCallback() {
        this.end = this.parseEnd();
        this.units = {};
        this.querySelectorAll('[data-unit]').forEach((el) => { this.units[el.dataset.unit] = el; });
        this.tick();
        this.interval = setInterval(() => this.tick(), 1000);
      }
      disconnectedCallback() {
        clearInterval(this.interval);
      }
      // Accepts "2026-11-15" + "9:00" or "09:00" and returns a timestamp (NaN if invalid).
      parseEnd() {
        const { date = '', time = '', tz = '' } = this.dataset;
        const [h = '0', m = '0'] = time.split(':');
        const hh = h.trim().padStart(2, '0');
        const mm = m.trim().padStart(2, '0');
        return new Date(`${date.trim()}T${hh}:${mm}:00${tz}`).getTime();
      }
      tick() {
        const pad = (v) => String(v).padStart(2, '0');
        const remaining = this.end - Date.now();
        if (Number.isNaN(this.end) || remaining <= 0) {
          this.querySelector('[data-timer]').hidden = true;
          this.querySelector('[data-done]').hidden = false;
          if (this.dataset.hide === 'true' && !(window.Shopify && window.Shopify.designMode)) {
            this.closest('.vcd').style.display = 'none';
          }
          clearInterval(this.interval);
          return;
        }
        const t = Math.floor(remaining / 1000);
        this.units.d.textContent = pad(Math.floor(t / 86400));
        this.units.h.textContent = pad(Math.floor((t % 86400) / 3600));
        this.units.m.textContent = pad(Math.floor((t % 3600) / 60));
        this.units.s.textContent = pad(t % 60);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["velune-temoignages"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('velune-testimonials')) {
    customElements.define('velune-testimonials', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.onClick = (event) => {
          const button = event.target.closest('[data-dir]');
          if (!button || !this.track) return;
          const card = this.track.querySelector('[data-card]');
          const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
          const step = card ? card.getBoundingClientRect().width + gap : this.track.clientWidth;
          this.track.scrollBy({ left: step * Number(button.dataset.dir), behavior: 'smooth' });
        };
        this.addEventListener('click', this.onClick);
      }
      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
